document.addEventListener('DOMContentLoaded', () => {
  console.log('CTY theme assets loaded');

  // Carousel functionality
  const carousel = document.getElementById('homeCarousel');
  if (carousel) {
    const slides = carousel.querySelectorAll('.carousel__slide');
    const prevBtn = carousel.querySelector('.carousel__prev');
    const nextBtn = carousel.querySelector('.carousel__next');
    const dotsContainer = carousel.querySelector('.carousel__dots');
    let currentSlide = 0;
    let autoplayInterval;

    // Create dots
    slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.className = `carousel__dot ${index === 0 ? 'active' : ''}`;
      dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
      dot.addEventListener('click', () => goToSlide(index));
      dotsContainer.appendChild(dot);
    });

    const dots = dotsContainer.querySelectorAll('.carousel__dot');

    function showSlide(index) {
      slides.forEach((slide, i) => {
        slide.classList.toggle('active', i === index);
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
      });
      currentSlide = index;
    }

    function nextSlide() {
      const next = (currentSlide + 1) % slides.length;
      showSlide(next);
    }

    function prevSlide() {
      const prev = (currentSlide - 1 + slides.length) % slides.length;
      showSlide(prev);
    }

    function goToSlide(index) {
      showSlide(index);
      resetAutoplay();
    }

    function startAutoplay() {
      autoplayInterval = setInterval(nextSlide, 5000);
    }

    function stopAutoplay() {
      clearInterval(autoplayInterval);
    }

    function resetAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    if (prevBtn) prevBtn.addEventListener('click', () => { prevSlide(); resetAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { nextSlide(); resetAutoplay(); });

    // Pause on hover
    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);

    // Start autoplay
    if (slides.length > 1) {
      startAutoplay();
    }
  }

  // Tabs functionality
  const tabButtons = document.querySelectorAll('.featured-tabs__tab');
  const tabPanels = document.querySelectorAll('.featured-tabs__panel');

  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      const targetTab = button.getAttribute('data-tab');

      // Remove active class from all buttons and panels
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabPanels.forEach(panel => panel.classList.remove('active'));

      // Add active class to clicked button and corresponding panel
      button.classList.add('active');
      const targetPanel = document.getElementById(`tab-${targetTab}`);
      if (targetPanel) {
        targetPanel.classList.add('active');
      }
    });
  });

  // Search Popup functionality
  const searchPopup = document.getElementById('searchPopup');
  const searchTrigger = document.querySelector('.greeting-bar__search-trigger');
  const searchClose = document.querySelector('.search-popup__close');
  const searchOverlay = document.querySelector('.search-popup__overlay');
  const searchInput = document.getElementById('searchPopupInput');

  function openSearchPopup() {
    if (searchPopup) {
      searchPopup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      // Focus input after animation
      setTimeout(() => {
        if (searchInput) {
          searchInput.focus();
        }
      }, 100);
    }
  }

  function closeSearchPopup() {
    if (searchPopup) {
      searchPopup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  if (searchTrigger) {
    searchTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      openSearchPopup();
    });
  }

  if (searchClose) {
    searchClose.addEventListener('click', closeSearchPopup);
  }

  if (searchOverlay) {
    searchOverlay.addEventListener('click', closeSearchPopup);
  }

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchPopup && searchPopup.getAttribute('aria-hidden') === 'false') {
      closeSearchPopup();
    }
  });

  // Mobile Menu Toggle
  const menuToggle = document.querySelector('.menu-toggle');
  const primaryMenu = document.querySelector('.primary-menu');
  const menuItems = document.querySelectorAll('.primary-menu .menu-item-has-children > a');

  if (menuToggle && primaryMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = primaryMenu.classList.contains('menu-open');
      
      if (isOpen) {
        primaryMenu.classList.remove('menu-open');
        menuToggle.classList.remove('active');
        menuToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      } else {
        primaryMenu.classList.add('menu-open');
        menuToggle.classList.add('active');
        menuToggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      }
    });

    // Close menu when clicking outside
    document.addEventListener('click', (e) => {
      if (primaryMenu.classList.contains('menu-open') && 
          !primaryMenu.contains(e.target) && 
          !menuToggle.contains(e.target)) {
        primaryMenu.classList.remove('menu-open');
        menuToggle.classList.remove('active');
        menuToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    });

    // Toggle submenu on mobile
    menuItems.forEach(item => {
      item.addEventListener('click', (e) => {
        if (window.innerWidth <= 768) {
          e.preventDefault();
          const parent = item.parentElement;
          parent.classList.toggle('active');
        }
      });
    });
  }
});

